var _defs, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew235({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.87,7.26a1.32,1.32,0,0,1-.1.51,1.25,1.25,0,0,1-.29.44A1.44,1.44,0,0,1,5,8.53a2,2,0,0,1-.74.12H3.72v1.49H3.15V6H4.32a2.32,2.32,0,0,1,.59.07,1.37,1.37,0,0,1,.49.22,1.07,1.07,0,0,1,.34.39A1.18,1.18,0,0,1,5.87,7.26Zm-.59,0A.72.72,0,0,0,5,6.68a1.13,1.13,0,0,0-.73-.21H3.72v1.7h.52A1.16,1.16,0,0,0,5,8,.78.78,0,0,0,5.28,7.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.37,10a2.65,2.65,0,0,1-1,.21A1.71,1.71,0,0,1,7,9.66a2.26,2.26,0,0,1-.47-1.55,2.84,2.84,0,0,1,.13-.9A2.12,2.12,0,0,1,7,6.53a1.66,1.66,0,0,1,.58-.43A1.89,1.89,0,0,1,8.36,6a2.22,2.22,0,0,1,.53,0,1.92,1.92,0,0,1,.48.15V6.7a2.72,2.72,0,0,0-.47-.19,2.12,2.12,0,0,0-.52-.06,1.14,1.14,0,0,0-.53.11,1.11,1.11,0,0,0-.4.31,1.35,1.35,0,0,0-.25.51,2.38,2.38,0,0,0-.09.68,2,2,0,0,0,.32,1.22,1.16,1.16,0,0,0,1,.4,2.1,2.1,0,0,0,.51-.06,2.64,2.64,0,0,0,.47-.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.12,8a3.45,3.45,0,0,1,0,.57,2.15,2.15,0,0,1-.15.51,1.41,1.41,0,0,1-.26.42,1.44,1.44,0,0,1-.4.33,1.9,1.9,0,0,1-.54.21,3,3,0,0,1-.71.08h-.88V6h1.06a1.93,1.93,0,0,1,1.45.5A2.12,2.12,0,0,1,13.12,8Zm-.6,0a2.66,2.66,0,0,0-.08-.74,1.14,1.14,0,0,0-.25-.49.85.85,0,0,0-.42-.27,1.78,1.78,0,0,0-.59-.09h-.49V9.65h.42Q12.52,9.65,12.52,8.06Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 3.7,
    width: 15,
    height: 8.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew235);
export default __webpack_public_path__ + "static/media/Symbolpack_New_235.61c0513dbe1b12d7927a5ecac813adec.svg";
export { ForwardRef as ReactComponent };